import { atom } from 'jotai';

export const isSnackbarInitializedAtom = atom(false);
